import Vue from "vue";
import Swal from "sweetalert2";
type VForm = Vue & { validate: () => boolean; reset: () => boolean; resetValidation: () => boolean; }
import ErrorService from "@/services/erroService";
import { AxiosInstance } from "axios";




export default class BaseComponent extends Vue {

  emailValidation(emails: any) {
    let result = true;
    if (emails instanceof Array && emails.length > 0) {
      emails.forEach((element: string) => {
        const valid = /^[_a-z0-9-+]+(\.[_a-z0-9-+]+)*(\+[a-z0-9-]+)?@[a-z0-9-.]+(\.[a-z0-9]+)$/.test(element);

        if (!valid) {
          result = valid;
        }
      });
      return result || 'E-mail must be valid';
    }
    else return /^[_a-z0-9-+]+(\.[_a-z0-9-+]+)*(\+[a-z0-9-]+)?@[a-z0-9-.]+(\.[a-z0-9]+)$/.test(emails) || 'E-mail must be valid';

  }


  emailValidationNoRequired(emails: any) {
    let result = true;
    if (emails instanceof Array && emails.length > 0) {
      emails.forEach((element: string) => {
        if (element) {
          const valid = /^[_a-z0-9-+]+(\.[_a-z0-9-+]+)*(\+[a-z0-9-]+)?@[a-z0-9-.]+(\.[a-z0-9]+)$/.test(element);

          if (!valid) {
            result = valid;
          }
        }
      });

    }
    else {
      if (emails) {
        const valid = /^[_a-z0-9-+]+(\.[_a-z0-9-+]+)*(\+[a-z0-9-]+)?@[a-z0-9-.]+(\.[a-z0-9]+)$/.test(emails);
        if (!valid) {
          result = valid;
        }
      }
    }

    return result || 'E-mail must be valid';

  }

  urlValidation(value: string) {
    if (value.length <= 256)
      return "URL must be less than 256 characters"; /* eslint-disable-next-line no-useless-escape*/
    return /https?:[0-9]*\/\/[\w!?/\+\-_~=;\.,*&@#$%\(\)\'\[\]]+/.test(value) || 'URL must be valid';
  }

  form(): VForm {
    return this.$refs.form as VForm;
  }

  get http(): AxiosInstance {
    return this.$http;
  }
  required(value: Array<unknown>) {
    if (value instanceof Array && value.length == 0) {
      return "Item is required";
    }
    else if (typeof value == "object" && Object.keys(value).length == 0) {
      return "Item is required";
    }
    return !!value || "Item is required";
  }

  requiredRadio(value: unknown) {
    if (value != null && (value as number) >= 0) return true;
    return !!value || "Item is required";
  }


  showError(message: string) {
    Swal.fire({
      title: 'Error',
      text: message,
      icon: "error",
    });
  }

  showSuccess(message: string) {
    Swal.fire({
      title: 'Success',
      text: message,
      icon: "success",
    });
  }

  logHttpError(httpResponse: any) {
    ErrorService.displayErrorAlert(httpResponse);
  }

  logException(exception: any) {
    ErrorService.displayErrorAlert(exception);
  }

  logGenericError(exception: any) {
    ErrorService.onError(exception);
  }

  convertToCSV(myJSON: any[]) {
    const escapeValue = (value: any) => {
      const content = (() => {
        if (!value) {
          return "";
        }
        if (typeof value === "object") {
          return JSON.stringify(value).replace(/"/g, '""')
        }
        return value.toString();
      })()
      return `"${content}"`
    };

    const fieldNamesArray: string[] = [...new Set(
      myJSON.reduce((acc, arrayEntry) => {
        return [...acc, ...Object.keys(arrayEntry)];
      }, [])
    )] as any[];

    const header = fieldNamesArray.map(escapeValue).join(',');

    const rows = myJSON.map(arrayEntry => {
      return fieldNamesArray.map((field) => {
        return escapeValue(arrayEntry[field]);
      }).join(',');
    }).join('\n');

    return `${header}\n${rows}`;
  }

  exportCSVFile(items: any, fileTitle: string) {

    const csv = this.convertToCSV(items);

    const exportedFilenmae = fileTitle + '.csv' || 'export.csv';

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    }
  }

  exportCSVFileV2(items: any, items2: any, fileTitle: string, subTitle: string) {

    let csv = this.convertToCSV(items);
    csv += `\n\n${subTitle}\n` + this.convertToCSV(items2);

    const exportedFilenmae = fileTitle + '.csv' || 'export.csv';

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    }
  }


}